module.exports = __webpack_public_path__ + "static/media/Menu-10.51281c20.jpg";